import { render, staticRenderFns } from "./AboutQualifications.vue?vue&type=template&id=29e60b24&scoped=true&"
import script from "./AboutQualifications.vue?vue&type=script&lang=js&"
export * from "./AboutQualifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e60b24",
  null
  
)

export default component.exports